import { useCallback } from 'react';
import { prop } from 'ramda';
import { useDispatch } from 'react-redux';
import { useAppSelector } from 'js/store/hooks';
import { TDepositResponse, TWithdrawResponse } from 'js/hooks/socket/types';
import { showCommonPopupAction } from 'js/components/common/popups/CommonPopup';

export const useHandleCashierNotification = () => {
    const dispatch = useDispatch();
    const sendCashierMessagesToGS = useAppSelector(prop('sendCashierMessagesToGS'));

    return useCallback((response: TDepositResponse | TWithdrawResponse): void => {
        const { ID, data } = response || {};
        const isDepositResponse = ID === 33015;

        if (isDepositResponse && sendCashierMessagesToGS) {
            return;
        }

        data.payments?.transaction?.forEach((transaction) => {
            dispatch(showCommonPopupAction({
                content: transaction.message,
                title: `playtech.mobile.system.mobile-cashier.${isDepositResponse ? 'deposit' : 'withdraw'}.title`
            }));
        });
    }, [dispatch, sendCashierMessagesToGS]);
};
